module.exports = __webpack_public_path__ + "img/max-person-check.02fcb2c3.svg";